
import { TFunction } from "i18next";

export function DisplayError(
  error: any,
  fallbackMessage?: string,
  t?: TFunction<"translation", undefined>
) {
  if (error && error.response && error.response.status !== 200) {
    const responseData = error.response.data;
    const errorMessage =
      responseData?.message || fallbackMessage || "Internal Error";

    let detailedErrors = "";
    if (responseData?.errors && typeof responseData.errors === "object") {
      detailedErrors = Object.entries(responseData.errors)
        .map(([, messages]) => {
          if (Array.isArray(messages)) {
            return typeof t === "function" ? t(`${messages.join(", ")}`) : `${messages.join(", ")}`;
          }
          return typeof t === "function" ? t(`${String(messages).toLowerCase()}`) : `${String(messages)}`;
        })
        .join("\n");
    }
    if (responseData?.error) {
      detailedErrors = responseData.error;
    }

    let description;

    if (detailedErrors) {
      description =
        typeof t === "function" ? t(`${detailedErrors.toLowerCase()}`) : detailedErrors;
    } else {
      description =
        typeof t === "function" ? t(`${errorMessage.toLowerCase()}`) : errorMessage;
    }

    return typeof t === "function" ? t(`${description.toLowerCase()}`) : description;
  } else if (!error.response) {
    return fallbackMessage || "Internal Error";
  }
}
